import { render } from "./Home.vue?vue&type=template&id=6db2275a"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=6db2275a&lang=css"
script.render = render

export default script